import axios from 'axios'
import * as types from '../../types'
import swear from '../../utils/swear'
import laroute from '../../../vendor/laroute'

const state = {}

const getters = {}

const actions = {
    [types.applicants.modules.submission.actions.store] ({ commit }, { sid, params, data = {} }) {
        return swear(() => {
            return axios
                .post(laroute.route('api.applicants.submission.store', params), data)
                .then(({ data: item }) => {
                    commit(types.applicants.mutations.stored, { sid, item })
                })
        }, sid)
    }
}

const mutations = {}

export default {
    state,
    getters,
    actions,
    mutations
}
